<template>
    <zbScrollbar :isKeep="isKeep">
        <van-pull-refresh
            v-model="store.isVanLoading"
            :disabled="isDisabledRefresh"
            @refresh="storeReLoad"
            class="van-list-container"
        >
            <!--
                :immediate-check="false" 初始化时不加载数据
            -->
            <van-list
                v-if="!isEmpty"
                v-model="store.isVanLoading"
                @load="storeLoadNext"
                :immediate-check="false"
                :finished="store.isFinished"
                :finished-text="finishedText"
                :error-text="useMessagee.error"
                :error.sync="store.isError"
            >
                <!--判断使用自定义插槽还是循环插槽，默认使用循环插槽 -->
                <slot v-if="isCustom"></slot>
                <div v-for="(item,i) in data" :key="i" :class="itemCls" v-else>
                    <slot v-bind:item="item"></slot>
                </div>
            </van-list>
            <div v-show="store.isLoading" class="noMessage">
                <div class="bv bc message-content">
                    <van-loading size="24px">加载中...</van-loading>
                </div>
            </div>
            <slot name="empty">
                <!-- 如果数据为空，并且不在加载状态 -->
                <div v-show="isEmpty&&!store.isLoading" class="noMessage">
                    <div class="bv bc message-content">
                        <div class="img"></div>
                        <div class="text">{{emptyMessage}}</div>
                    </div>
                </div>
            </slot>
        </van-pull-refresh>
    </zbScrollbar>
</template>
<script>
import store from "@/utils/store";
import zbScrollbar from "@/components/scroll/Bar";
export default {
    components: { zbScrollbar },
    model: {
        // 双向绑定
        prop: "store",
        event: "updateStore"
    },
    props: {
        // 是否缓存页面信息
        // 为true时会缓存滚动条信息
        isKeep: {
            type: Boolean,
            default: false
        },
        // 无数据提示信息
        emptyMessage: {
            type: String,
            default: "暂无数据哦！"
        },
        // 是否自定义数据模版
        isCustom: {
            type: Boolean,
            default: false
        },
        // 是否使用自定义方法
        isCustomEmit: { type: Boolean, default: false },
        // 列表css
        itemCls: {
            type: String,
            default: "list-item"
        },
        // 提示文字
        message: {
            type: Object
        },
        // store 数据源
        store: {
            type: Object,
            default() {
                return {
                    data: [],
                    isVanLoading: false,
                    isError: false
                };
            }
        },
        // 是否禁用下拉刷新
        isDisabledRefresh: {
            type: Boolean
        },
        // finishedText显示必须大于或等于最小条数
        minLen: {
            type: Number,
            default: 3
        }
    },
    data() {
        return {
            // 默认加载消息配置
            defaultLoadMessage: {
                finished: "哎呀，已经滑到底了",
                noMore: "没有更多数据了",
                error: "请求失败，点击重新加载"
            }
        };
    },
    computed: {
        // 使用的加载消息配置
        useMessagee() {
            // 默认配置与父组件配置
            return Object.assign(this.defaultLoadMessage, this.message);
        },
        // 数据源
        data() {
            return this.store.data;
        },
        // 是否为空
        isEmpty() {
            return !this.data.length;
        },
        // 当数据总条数大于等于指定值时才显示没有数据的提示
        finishedText() {
            const me = this,
                mes = me.useMessagee;
            return me.data.length >= me.minLen ? mes.finished : mes.noMore;
        }
    },
    methods: {
        // 加载更多
        storeLoadNext() {
            const me = this;
            if (!me.isCustomEmit) {
                store.loadNext(me.store);
            } else {
                me.store.isVanLoading = false;
            }
            // 抛出事件
            me.$emit("loadNext");
        },
        // 重载
        storeReLoad() {
            const me = this;
            if (!me.isCustomEmit) {
                store.reLoad(me.store);
            } else {
                me.store.isVanLoading = false;
            }
            // 抛出事件
            me.$emit("reLoad");
        }
    }
};
</script>
